/* eslint-disable prettier/prettier */
import axios from 'axios';
import { clearSession, updateSessionToken } from './auth';
import { API_URLS } from './apiUrls';


export const setupAxiosInterceptors = () => {
    axios.interceptors.request.use((config) => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    let isRefreshing = false;
    let failedQueue = [];

    const processQueue = (error, token = null) => {
        failedQueue.forEach((prom) => {
            if (error) {
                prom.reject(error);
            } else {
                prom.resolve(token);
            }
        });
        failedQueue = [];
    };

    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;
            console.log(error.code);

            // Check for status code 401
            // if (
            //   error.response?.status === 401 &&
            //   !originalRequest._retry &&
            //   !originalRequest.url.includes()
            // ) {

            // Replace this if statement with above statement (Currently API does not return 401)
            if (
                error.code === "ERR_NETWORK" &&
                !originalRequest._retry &&
                !originalRequest.url.includes(API_URLS.REFRESH_TOKEN)
            ) {
                originalRequest._retry = true;

                // Add incoming requests to Queue while refreshing token
                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    }).then((token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        return axios(originalRequest);
                    });
                }

                isRefreshing = true;

                try {
                    const refreshToken = sessionStorage.getItem('refreshToken');
                    // console.log(refreshToken);
                    const response = await axios.post(
                        API_URLS.REFRESH_TOKEN,
                        { RefreshToken: refreshToken }
                    );
                    // console.log('response', response.data);
                    if (!response.data.IsSuccess) {
                        processQueue(error, null);
                        clearSession(); // Optional: logout on refresh failure
                        return Promise.reject(error);
                    }
                    const newAccessToken = response.data.Response.Token;
                    const newRefreshToken = response.data.Response.TokenRefresh;
                    updateSessionToken(newAccessToken, newRefreshToken);

                    processQueue(null, newAccessToken);

                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return axios(originalRequest);
                } catch (err) {
                    processQueue(err, null);
                    clearSession(); // Optional: logout on refresh failure
                    // window.location.href = '/';
                    return Promise.reject(err);
                } finally {
                    isRefreshing = false;
                }
            }

            return Promise.reject(error);
        }
    );

    return axios;
};